import BottomSheet from "./BottomSheet";
import EntryForm from "./EntryForm";
import {
  EXTRA_FIELDS,
  STATUS_OPTIONS,
  TITLE_PLACEHOLDERS,
  TYPE_ORDER,
  TYPE_STYLES,
} from "../utils/constants";
import {
  formCardStyle,
  formRowStyle,
  inputStyle,
  saveButtonStyle,
  TOKENS as T,
  typeButtonsStyle,
  typeButtonStyle,
} from "../styles/styles";

// Sheet chrome around the existing EntryForm. Single implementation, shared by
// Tracker and Search — the form itself is untouched.
export default function EntryFormSheet({
  draft,
  onDraftChange,
  onSaveEntry,
  onCancel,
}) {
  return (
    <BottomSheet onClose={onCancel}>
      <div style={headerStyle}>
        <h2 style={titleStyle}>
          {draft.id ? "Edit entry" : "What are you into?"}
        </h2>
        <p style={subtitleStyle}>
          {draft.id
            ? "Update the details, rating or status."
            : "Add it once — everyone in the group sees it."}
        </p>
      </div>

      <EntryForm
        draft={draft}
        onDraftChange={onDraftChange}
        onSaveEntry={onSaveEntry}
        typeOrder={TYPE_ORDER}
        typeStyles={TYPE_STYLES}
        statusOptions={STATUS_OPTIONS}
        extraFields={EXTRA_FIELDS}
        titlePlaceholders={TITLE_PLACEHOLDERS}
        formCardStyle={formCardStyle}
        typeButtonsStyle={typeButtonsStyle}
        typeButtonStyle={typeButtonStyle}
        inputStyle={inputStyle}
        formRowStyle={formRowStyle}
        saveButtonStyle={saveButtonStyle}
      />

      <button type="button" style={cancelButtonStyle} onClick={onCancel}>
        Cancel
      </button>
    </BottomSheet>
  );
}

const headerStyle = {
  paddingTop: 4,
  marginBottom: 16,
};

const titleStyle = {
  margin: "0 0 8px",
  fontSize: 20,
  fontWeight: 700,
  lineHeight: 1.25,
  color: T.foreground,
};

const subtitleStyle = {
  margin: 0,
  fontSize: 13,
  lineHeight: 1.6,
  color: T.mutedForeground,
};

const cancelButtonStyle = {
  width: "100%",
  padding: "14px 16px",
  borderRadius: 16,
  border: `1px solid ${T.border}`,
  background: T.card,
  color: T.foreground,
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "inherit",
  cursor: "pointer",
  marginTop: 12,
};
